import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import {
  setSecurityToken as setST,
  setRecaptchaToken as setRT,
} from './security.slice';
import { useGenerateTokenMutation } from './security.api';
import { useDispatch, useSelector } from 'react-redux';

export default function useSecurity() {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const dispatch = useDispatch();
  const [callSecurityToken] = useGenerateTokenMutation();

  const security = useSelector((state) => state.security);

  const setRecaptchaToken = (token) => {
    dispatch(setRT(token));
  };

  const setSecurityToken = (token) => {
    dispatch(setST(token));
  };

  const getReCaptchaToken = async () => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available');
      return;
    }

    const token = await executeRecaptcha('submit');
    setRecaptchaToken(token);
    return token;
  };

  const generateSecurityToken = async () => {
    if (process.env.NEXT_PUBLIC_USE_SECURITY === 'true') {
      const recaptchaToken = await getReCaptchaToken();
      const { data: securityToken } = await callSecurityToken(recaptchaToken);
      if (securityToken) {
        const { token } = securityToken;
        setSecurityToken(token);
        return token;
      }
      return null;
    }
    if (process.env.NEXT_PUBLIC_USE_SECURITY !== 'true') {
      return true;
    }
  };

  return { security, generateSecurityToken };
}
